<template lang="pug">
yz-card.mb-6(outlined)
  .pa-6
    //- Header row (always visible)
    .d-flex.align-center.justify-space-between
      .d-flex.align-center
        .yz-heading-8.text-neutral-700.mr-2 e-Invoice details
        yz-badge(color="neutral-200" text-color="neutral-700")
          .d-flex.align-center
            yz-dot.mr-1(size="6px" color="neutral-500")
            span.yz-regular-body-xs Unsubmitted: Complete details and tick submit to generate e-Invoice
      .d-flex.align-center
        yz-checkbox.mr-2(v-model="submitEInvoice" label="Submit e-Invoice after creating this invoice")
        v-btn(icon small @click="expanded = !expanded")
          v-icon(size="16") {{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}

    //- Expanded content
    template(v-if="expanded")
      v-divider.my-5
      v-row(no-gutters)
        //- Left column
        v-col.pr-5
          .yz-medium-body-sm.text-neutral-700 Name
          yz-text-field.mt-1(v-model="name" size="md" placeholder="Enter name")
          .yz-medium-body-sm.text-neutral-700.mt-4 Income Tax Number (TIN)
          yz-text-field.mt-1(v-model="tin" size="md" placeholder="Enter TIN")
          .yz-medium-body-sm.text-neutral-700.mt-4 Phone number
          yz-phone-input.mt-1(v-model="phone" size="md")
          .yz-medium-body-sm.text-neutral-700.mt-4 Email
          yz-text-field.mt-1(v-model="email" size="md" placeholder="Enter email")
          yz-checkbox.mt-2(v-model="sendCopyToPatient" label="Send copy to patient")
        //- Right column (with left border)
        v-col.pl-5(style="border-left: 1px solid var(--yz-neutral-300)")
          .yz-medium-body-sm.text-neutral-700 Address
          yz-address-input.mt-1(:line1.sync="addressLine1" :line2.sync="addressLine2" :postcode.sync="addressPostcode" :city.sync="addressCity" :state.sync="addressState" type="malaysia" size="md")
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    parentData: {
      type: Object,
      default: null
    },
    selectedDocument: {
      type: Object,
      required: true
    },
  },
  data () {
    return {
      expanded: false,
      submitEInvoice: false,
      name: '',
      tin: '',
      phone: '',
      email: '',
      sendCopyToPatient: false,
      addressLine1: '',
      addressLine2: '',
      addressPostcode: '',
      addressCity: '',
      addressState: '',
    }
  },
  watch: {
    submitEInvoice (newValue) {
      this.$emit('input', { ...this.value, submitEInvoice: newValue })
    },
    name (newValue) {
      this.$emit('input', { ...this.value, name: newValue })
    },
    tin (newValue) {
      this.$emit('input', { ...this.value, tin: newValue })
    },
    phone (newValue) {
      this.$emit('input', { ...this.value, phone: newValue })
    },
    email (newValue) {
      this.$emit('input', { ...this.value, email: newValue })
    },
    sendCopyToPatient (newValue) {
      this.$emit('input', { ...this.value, sendCopyToPatient: newValue })
    },
    addressLine1 (newValue) {
      this.$emit('input', { ...this.value, addressLine1: newValue })
    },
    addressLine2 (newValue) {
      this.$emit('input', { ...this.value, addressLine2: newValue })
    },
    addressPostcode (newValue) {
      this.$emit('input', { ...this.value, addressPostcode: newValue })
    },
    addressCity (newValue) {
      this.$emit('input', { ...this.value, addressCity: newValue })
    },
    addressState (newValue) {
      this.$emit('input', { ...this.value, addressState: newValue })
    },
  },
}
</script>
